export default __webpack_public_path__ + "static/media/ORYX_ReportStatusIcon.99e2e3e3.svg";